export enum StockFilterTypeEnum {
  all = 'all',
  issued = 'issued',
  held = 'held',
  sold = 'sold',
}

export type StocksSummary = {
  total_number_stocks_issued: number;
  total_value_stocks_issued: number;
  total_number_stocks_held: number;
  total_value_stocks_held: number;
  total_number_stocks_sold: number;
  total_value_stocks_sold: number;
};

export type StockData = {
  seller_name: string;
  buyer_name: string;
  stock_issuance_date: string;
  stock_sale_date: string | null;
  purchase_price: number;
  eii_purchase_value: number;
  current_price: number;
  current_eii_value: number;
  stock_serial_number: string;
};

export type StocksData = {
  issued: StockData[];
  held: StockData[];
  sold: StockData[];
};

/** GET /api/v1/stocks/stock-summary/{org_id}/ */
export const GET_ORGANIZATION_STOCK_SUMMARY_PATH = 'stocks/stock-summary/{organization_id}';
export type GetOrganizationStockSummaryPathVariables = { organization_id: string };
export type GetOrganizationStockSummaryQueryParams = undefined;
export type GetOrganizationStockSummarySuccessDto = {
  organization_id: string;
  currency_code: string;
  stock_summary: StocksSummary;
};
export type GetOrganizationStockSummaryErrorDto = Error;
